import React from 'react';
import Protection from './Protection';

const Protections = ({ product }) => {
	let ulIcon;
	let etlIcon;
	const protection = product.protections.map(
		(protection,index) => <Protection key={ index } protection={ protection } />
	);

	if (product.ulIcon === '1') {
		ulIcon = (
			<li>
				<img
					src={ require('../../resources/img/icons/UL-logo.png') }
					alt="UL Fire Endurance"
				/>
			</li>
		);
	}

	if (product.etlIcon === '1') {
		etlIcon = (
			<li>
				<img
					src={ require('../../resources/img/icons/ETL-logo.png') }
					alt="ETL Verified Endurance"
				/>
			</li>
		);
	}

	return (
		<section className="protection-type" id="protection">
			<ul className="classification">
				{ ulIcon }
				{ etlIcon }
			</ul>
			<div className="row">
				<h3 className="title">
					Top of the Line Protection
				</h3>
			</div>
			<ul className="callout">
				{ protection }
			</ul>
		</section>
	);
};

export default Protections;


// WEBPACK FOOTER //
// ./src/pages/product/Protections.js